import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import { FORM_LAYOUT_CONFIG, FORM_FOOTER_CONFIG } from 'config/app.config';
import { Form, Select, Input, Button, Icon, notification } from 'antd';
import { validator } from 'utils/validateMessagesUtil';
import styles from '../index.less';
import { addIpAddress, updateIpAddress, resetIpDetail, fetchIpDetail } from '../flow/action';

const cx = classNames.bind(styles);
const { PhantomId } = Enums;
const { Option } = Select;
const { Item } = Form;

class IpListForm extends React.Component {
  componentDidMount() {
    const { fetchIpDetail, currentId } = this.props;
    if (currentId !== PhantomId) {
      fetchIpDetail(currentId);
    }
  }

  componentWillUnmount() {
    const { resetIpDetail } = this.props;
    resetIpDetail();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const {
      form,
      history,
      intl,
      currentId,
      updateIpAddress,
      addIpAddress,
    } = this.props;
    const { formatMessage } = intl;
    form.validateFields((err, values) => {
      if (!err) {
        if (currentId === PhantomId) {
          addIpAddress(values, () => {
            history.push('/setup/systems/ip-setting');
          });
        } else {
          updateIpAddress(currentId, values, () => {
            history.push('/setup/systems/ip-setting');
          });
        }
      } else {
        notification.error({
          message: formatMessage({ id: 'page.IpWhiteLists.errorMsg' }),
          duration: 3,
        });
      }
    });
  }

  handleCancel = () => {
    const { history } = this.props;
    history.push('/setup/systems/ip-setting');
  }

  render() {
    const { currentPageData, intl, form } = this.props;
    const formItemLayout = FORM_LAYOUT_CONFIG;
    const { formatMessage, locale } = intl;
    const errorMsg = formatMessage({ id: 'page.IpWhiteLists.errorMsg' });
    const { getFieldDecorator } = form;
    const {
      id,
      ip_address,
      ip_status,
      comment,
    } = currentPageData;
    return (
      <div className={cx('iplists-edit-wrapper')}>
        <Form onSubmit={e => this.handleSubmit(e)}>
          <Item
            {...formItemLayout}
            label={formatMessage({ id: 'page.IpWhiteLists.ipAddress' })}
          >
            {getFieldDecorator('ip_address', {
                initialValue: ip_address || '',
                rules: [{ required: true, validator: validator.ipValid(locale) }],
              })(<Input />)}
          </Item>
          <Item
            {...formItemLayout}
            label={formatMessage({ id: 'page.IpWhiteLists.ipStatus' })}
          >
            {getFieldDecorator('ip_status', {
                initialValue: Number(ip_status) === 0 ? 0 : 1,
                rules: [{ required: true, message: errorMsg }],
              })(
                <Select>
                  <Option value={1}>{formatMessage({ id: 'page.IpWhiteLists.actived' })}</Option>
                  <Option value={0}>{formatMessage({ id: 'page.IpWhiteLists.inActived' })}</Option>
                </Select>
              )}
          </Item>
          <Item
            {...formItemLayout}
            label={formatMessage({ id: 'page.IpWhiteLists.comment' })}
          >
            {getFieldDecorator('comment', {
                initialValue: comment || '',
              })(<Input />)}
          </Item>
          <Item {...FORM_FOOTER_CONFIG}>
            <Button type="primary" htmlType="submit" onClick={e => this.handleSubmit(e)}>
              <Icon type="save" />{formatMessage({ id: 'global.ui.button.save' })}
            </Button>
            <Button type="danger" className="ml-sm" onClick={e => this.handleCancel(e)}>
              <Icon type="close" />{formatMessage({ id: 'global.ui.button.cancel' })}
            </Button>
          </Item>
        </Form>
      </div>
    );
  }
}

IpListForm.defaultProps = {};
IpListForm.propTypes = {
  currentPageData: PropTypes.object.isRequired,
  currentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const IpListFormWrapped = Form.create()(IpListForm);

const mapStateToProps = ({ setup, global }) => ({
  language: global.language,
  currentPageData: setup.ipLists.CurrentPageData,
});

const mapDispatchToProps = {
  addIpAddress,
  updateIpAddress,
  resetIpDetail,
  fetchIpDetail,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(IpListFormWrapped)));



// WEBPACK FOOTER //
// ./src/views/Setup/IpWhiteLists/component/IpListForm.jsx